import * as React from "react";

function VideoUpload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg style={{ color: 'var(--brand, #365d7e)' }} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#EDEDED" />
      <rect x="2" y="2" width="32" height="32" rx="16" stroke="#FAFAFA" stroke-width="4" />
      <path d="M14.6666 11.3333V24.6667M21.3333 11.3333V24.6667M11.3333 18H24.6666M11.3333 14.6667H14.6666M11.3333 21.3333H14.6666M21.3333 21.3333H24.6666M21.3333 14.6667H24.6666M12.7866 11.3333H23.2133C24.0159 11.3333 24.6666 11.984 24.6666 12.7867V23.2133C24.6666 24.016 24.0159 24.6667 23.2133 24.6667H12.7866C11.9839 24.6667 11.3333 24.016 11.3333 23.2133V12.7867C11.3333 11.984 11.9839 11.3333 12.7866 11.3333Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export default VideoUpload;
